export default {"src":"/_next/static/media/microsoft-outlook-logo.5a897eeb.svg","height":1703,"width":1831,"blurWidth":0,"blurHeight":0};